import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isDev',
})
export class IsDevPipe implements PipeTransform {
  transform(user: any): boolean {
    if (!user) {
      return false;
    }
    const { claims } = user;
    if (!claims.dev) {
      return false;
    }

    return true;
  }
}
